import React, {Component, Fragment} from 'react';
import {Card, CardBody, CardHeader, Col, FormGroup, FormText, Input, InputGroup, Label, Row, Table} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData} from '../../api/doLogin.js';
import {toURLEncodedString} from "../../util/dataHelpers";
import {formsUpdater, getFormFieldValue} from "../Applications/shared/shared";
import {formatDate} from "../../util/datehelpers";
import {EventClient} from "../../util/eventClient";
import {getLMSStatus} from "../../constants/LMSConstants";
import {getGlobalState} from "../../constants/GlobalStore";
import {DropSelection} from "../Leads/components/DropSelection";
import {LoadingOverlay} from "../../components/Shared/LoadingOverlay";
import {PromptDialog} from "../Shared/PromptDialog";
import {toast} from "react-toastify";
import {patchData} from "../../api/doLogin";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class IntakeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      campaignList: [],
      subSourceList: [],
      data: [],
      dataIntake: [],
      dataOffice: {},
      dataLoaded: true,
      officeVisible: [],
      sourceVisible: [],
      calendarMenu: [],
      formData: {
        sort: "Office",
        startdate: formatDate(new Date()),
        enddate: formatDate(new Date()),
        campaign: "0"
      },
      noteEdit: null,
      processing: false
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 50,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
  }

  toggleVisible(type, value) {
    this.setState({[type + "Visible"]: this.state[type + "Visible"].indexOf(value) === -1 ? this.state[type + "Visible"].concat(value) : [...this.state[type + "Visible"].filter((val) => val !== value)]});
  }

  componentDidMount() {
    this.updateSubList();
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevProps.match.params.type !== this.props.match.params.type) {
    //   this.updateData();
    // }
  }

  saveNote(id, note, callback) {
    let self = this;
    this.setState({processing: true});
    patchData(`leadintakes/${id}`, {note})
      .then((data) => {
        if (data.status === "Success") {
          self.setState({processing: false}, () => {
            callback(true);
          });
        } else {
          callback(false);
        }
      })
      .catch(error => {
        toast.error("Error saving note");
        console.error(error);
        callback(false);
      });
  }

  updateSubList() {
    let self = this;
    const {startdate, enddate, campaign} = this.state.formData;
    let qData = toURLEncodedString({startdate, enddate});
    this.setState({processing: true});
    getData(`leadintakes/campaign/${campaign || 0}${qData.length > 0 ? `?${qData}` : ""}`, {})
      .then((data) => {
        if (data.status === "Success") {
          const updateData = {
            campaignList: data.data.campaigns,
            calendarMenu: data.data.calendarMenu
          }
          if (data.data.subSourceList) {
            updateData.subSourceList = data.data.subSourceList;
          }
          // console.log(updateData)
          self.setState({...updateData, dataLoaded: true, processing: false});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  updateData() {
    var self = this;
    let qData = toURLEncodedString(this.state.formData);
    this.setState({processing: true});
    getData(`leadintakes/list${qData.length > 0 ? `?${qData}` : ""}`, {})
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          function groupByOfficeAndSource(data) {
            let officeGroup = {};
            data.forEach((val, i) => {
              if (!officeGroup[val.office]) {
                officeGroup[val.office] = {};
              }
              if (!officeGroup[val.office][val.source]) {
                officeGroup[val.office][val.source] = [];
              }
              if (!officeGroup[val.office][val.source].find((val2) => val2.id === val.id)) {
                officeGroup[val.office][val.source].push(val);
              }
            });
            return officeGroup;
          }

          function intakeDedupe(data) {
            let intakeData = [];
            data.forEach((val, i) => {
              if (!intakeData.find((val2) => val2.id === val.id)) {
                intakeData.push(val);
              }
            });
            return intakeData;
          }

          const intakeData = data.data.intakes;

          self.setState({
            data: intakeData,
            dataIntake: intakeDedupe(intakeData),
            dataOffice: groupByOfficeAndSource(intakeData),
            processing: false
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  exportJSONToCSV(objArray) {
    let arr = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(arr[0])
        .map((value) => `"${value}"`)
        .join(',')}` + '\r\n';
    let csvContent = arr.reduce((st, next) => {
      st +=
        `${Object.keys(next)
          .map((value) => {
            if (value === "lms_status") {
              return `"${getLMSStatus(next[value]).display}"`
            } else {
              return `"${next[value]}"`
            }
          })
          .join(',')}` + '\r\n';
      return st;
    }, str);
    let element = document.createElement('a');
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
    element.target = '_blank';
    element.download = 'export.csv';
    element.click();
  }

  saveCSV() {
    this.exportJSONToCSV(this.state.data);
  }

  render() {
    let self = this;
    return (
      <div className="animated fadeIn">
        <LoadingOverlay show={this.state.processing} fillAvailable={true}/>
        {this.state.noteEdit && (
          <PromptDialog defaultValue={this.state.noteEdit.note}
                        onSave={(val) => {
                          const data = this.state.data;
                          this.saveNote(this.state.noteEdit.id, val, (saved) => {
                            if (!saved) return this.setState({noteEdit: null});
                            data.forEach((intake) => {
                              if (intake.id === this.state.noteEdit.id) {
                                intake.note = val;
                              }
                            })
                            this.setState({data, noteEdit: null});
                          });
                        }}
                        onCancel={() => {
                          this.setState({noteEdit: null});
                        }}
          />
        )}
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"/>Intakes

              <div className="card-actions">
                {this.state.data && this.state.data.length > 0 && (
                  <button onClick={() => this.saveCSV()} style={{width: 75}}>
                    <small className="text-muted">Export CSV</small>
                  </button>
                )}
                <button onClick={() => this.updateData()} style={{width: 75}}>
                  <small className="text-muted">Search &gt;&gt;</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <Row>
                <Col sm={6} md={3}>
                  <FormGroup>
                    <Label for="startdate">Start Date</Label>
                    <InputGroup>
                      <Input
                        type="date"
                        id="startdate"
                        placeholder="date"
                        max={formatDate(new Date())}
                        value={getFormFieldValue(this.state.formData['startdate'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                          // this.dateValidator('end');
                          this.updateSubList();
                        })}
                      />
                    </InputGroup>
                    <FormText color="muted">
                      ex. 10/23/2019
                    </FormText>
                  </FormGroup>
                </Col>
                <Col sm={6} md={3}>
                  <FormGroup>
                    <Label for="enddate">End Date</Label>
                    <InputGroup>
                      <Input
                        type="date"
                        id="enddate"
                        placeholder="date"
                        max={formatDate(new Date())}
                        value={getFormFieldValue(this.state.formData['enddate'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                          // this.dateValidator('end');
                          this.updateSubList();
                        })}
                      />
                    </InputGroup>
                    <FormText color="muted">
                      ex. 10/23/2019
                    </FormText>
                  </FormGroup>
                </Col>
                <Col sm="9" md="4">
                  <FormGroup>
                    <Label for="campaign">Campaign</Label>
                    <Input type="select" id="campaign" placeholder=""
                           value={getFormFieldValue(this.state.formData['campaign'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => this.updateSubList())}
                    >
                      <option value={"0"}>All</option>
                      {(this.state.campaignList || []).map((val, i) => {
                        return <option key={i} value={val.id}>{val.source}</option>
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="3" md="2">
                  <FormGroup>
                    <Label for="sort">Sort</Label>
                    <Input type="select" id="sort" placeholder=""
                           value={getFormFieldValue(this.state.formData['sort'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    >
                      <option value={"Office"}>Office</option>
                      <option value={"Date"}>Date</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {this.state.data.length > 0 ?
                <Fragment>
                  {this.state.formData.sort === "Office" && this.renderOffice(this.state.dataOffice, this.state.dataIntake)}
                  {this.state.formData.sort === "Date" && this.renderIntakeList(this.state.dataIntake, false)}
                </Fragment>
                :
                <div style={{textAlign: "center"}}>No Intakes. Select options above or change your parameters and click
                  Search.</div>
              }
            </CardBody>
          </Card>
        )}
      </div>
    )
  }

  renderOffice(officeData, totalData) {
    // console.log(officeData);
    return <Table hover bordered striped responsive size="sm">
      <thead>
      <tr>
        <th width="60%">Office</th>
        <th width="15%">New Leads</th>
        <th width="15%">Existing Leads</th>
        <th width="10%">Total</th>
      </tr>
      </thead>
      <tbody>
      {officeData && Object.keys(officeData).map((data) => {
        const dataSources = officeData[data];
        const newLeads = totalData.filter((val) => val.office === data && val.status === "New").length;
        const existingLeads = totalData.filter((val) => val.office === data && val.status !== "New").length;
        const totalLeads = newLeads + existingLeads;
        return <Fragment key={data}>
          <tr style={{cursor: "pointer"}} onClick={() => this.toggleVisible("office", data)}>
            <td>{data}</td>
            <td>{newLeads}</td>
            <td>{existingLeads}</td>
            <td>{totalLeads}</td>
          </tr>
          {this.state.officeVisible.indexOf(data) > -1 && (
            <tr>
              <td colSpan={4}>
                {this.renderSourceList(dataSources, totalData, data)}
              </td>
            </tr>
          )}
        </Fragment>
      })}
      </tbody>
    </Table>
  }

  renderSourceList(sourceData, totalData, office) {
    return <Table hover bordered responsive size="sm">
      <thead>
      <tr>
        <th width="60%">Event</th>
        <th width="15%">New Leads</th>
        <th width="15%">Existing Leads</th>
        <th width="10%">Total</th>
      </tr>
      </thead>
      <tbody>
      {sourceData && Object.keys(sourceData).map((data) => {
        const dataSources = sourceData[data];
        const newLeads = totalData.filter((val) => val.source === data && val.status === "New" && (office && office === val.office)).length;
        const existingLeads = totalData.filter((val) => val.source === data && val.status !== "New" && (office && office === val.office)).length;
        const totalLeads = newLeads + existingLeads;
        return <Fragment key={data}>
          <tr style={{cursor: "pointer"}} onClick={() => this.toggleVisible("source", `${office}${data}`)}>
            <td>{data}</td>
            <td>{newLeads}</td>
            <td>{existingLeads}</td>
            <td>{totalLeads}</td>
          </tr>
          {this.state.sourceVisible.indexOf(`${office}${data}`) > -1 && (
            <tr>
              <td colSpan={4}>
                {this.renderIntakeList(dataSources)}
              </td>
            </tr>
          )}
        </Fragment>
      })}
      </tbody>
    </Table>
  }

  renderIntakeList(data) {
    let calendarMenu = (this.state.calendarMenu || []).filter((cal) => cal.fwrite === 1).map((cal) => ({
      display: `${cal.fname} ${cal.lname}`.trim(),
      value: cal.uid
    })).sort((a, b) => a.display.localeCompare(b.display));
    return <Table hover bordered responsive size="sm">
      <thead>
      <tr>
        <th width="20%">Lead</th>
        <th width="20%">Phone/Email</th>
        <th width="20%">Date</th>
        <th width="5%">New</th>
        <th width="10%">Status</th>
        <th width="25%">Notes</th>
      </tr>
      </thead>
      <tbody>
      {data && data.map((data) => {
        return <Fragment key={`${data.id}`}>
          <tr>
            <td><a href={"javascript:void(0);"}
                   style={{color: "#000"}}
                   onClick={() => EventClient.emit("LMS_ENTRY_EDIT", data.lms_id)}>{data.fname} {data.lname}</a>
              <div>
                <DropSelection displayText={"Schedule"}
                               noPadding={true}
                               items={{
                                 calendar: {
                                   header: "Select Calendar...",
                                   options: calendarMenu,
                                   selected: []
                                 }
                               }}
                               onClick={(category, value) => {
                                 window.open(`/calendar/${value || getGlobalState('loginID')}/schedule/${data.lms_id}`)
                               }}
                />
              </div>
            </td>
            <td>{data.phone} {data.email}</td>
            <td>{data.dated.split("T").join(" ").replace(".000Z", "")}</td>
            <td>{data.status === "New" ? "Y" : "N"}</td>
            <td>{getLMSStatus(data.lms_status).display}</td>
            <td>
              <a href={"javascript:void(0);"}
                 style={{color: "#000"}}
                 onClick={() => this.setState({
                   noteEdit: {
                     id: data.id,
                     note: data.note
                   }
                 })}>
                {data.note || "Leave Note..."}
              </a>
            </td>
          </tr>
        </Fragment>
      })}
      </tbody>
    </Table>
  }
}

export default IntakeList;



// WEBPACK FOOTER //
// ./src/containers/Intakes/IntakeList.js